import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export type dateProps = {
  children?: ReactNode;
  className?: string;
};

export default function Date({ children, className }: dateProps) {
  return (
    <p
      className={twMerge(
        "font-opensans font-normal text-grey-500 text-sm leading-7",
        className,
      )}
    >
      {children}
    </p>
  );
}
